const scenePageMap = {
  home: '/',
  market: '/market',
  catering: '/catering',
  about: '/about',
  games: '/games',
  boutique: '/boutique'
};

const pageConfig = {
  initialScene: 'market',
  navigationMode: 'spa',
  history: true,
  scenePageMap,
  prefetchScenes: ['home', 'catering', 'about', 'games', 'boutique']
};

window.__BUBAR_PAGE__ = pageConfig;
import('../core/page.js').catch(err => console.error('Failed to load page runtime', err));
